/* Requiere de genesys.js */

var cliente = {
	data () {
		return {
			listCliente: [],
			listVinculoCli: []
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getVinculoCli(clicod) {
            let url = this.urlAPICliente + '/getVinculoCli?clicod=' + clicod
            this.$emit('showLockScreen', 'Buscando clientes vinculados')
            this.axios.get(url)
                .then(response => { this.getVinculoCliResult(response); this.$emit('hideLockScreen') })
                .catch(error  => { console.log(error); this.$emit('hideLockScreen') })
        },
        getVinculoCliResult(response) {
            this.listVinculoCli = response.data.data
            this.getVinculoCliResultLocal(response)
        },
        getVinculoCliResultLocal(response) {
            console.log(response)
        }
	},
};

export default cliente;